// extracted by mini-css-extract-plugin
export default {"header":"Footer_header__Xoukj","mainContainer":"Footer_mainContainer__pmPbj","item":"Footer_item__9SCKy"};